module.exports = __webpack_public_path__ + "src/assets/games/31/305.jpg";